import React from "react";
import { useGetGamificationGuide } from "../../api/award";
import { theme } from "../_section/RewardSystem";
import RenderIf from "../../../../core/components/render-if";
import Modal from "../../../../core/components/modal";

function GamificationGuideModal({ open, onClose }) {
    const { data: gamificationGuideData } = useGetGamificationGuide();

    return (
        <Modal
            isOpen={open}
            onClose={onClose}
            title="راهنمای بازی‌واره"
            maxWidth="700px"
        >
            <div
                className="max-h-[70vh] overflow-y-auto"
            >
                <RenderIf cond={!!gamificationGuideData?.data?.text}>
                    <div
                        className="rounded-2xl p-3"
                        style={{
                            background: `${theme.primary}11`,
                            border: `1px solid ${theme.light}22`,
                            color: theme.light,
                        }}
                    >
                        <div
                            className="leading-8 whitespace-pre-line text-sm"
                            style={{ color: theme.primary }}
                        >
                            <p>
                                {gamificationGuideData?.data?.text}
                            </p>
                        </div>
                    </div>
                </RenderIf>

                <RenderIf cond={!gamificationGuideData?.data?.text}>
                    <div
                        className="rounded-2xl p-8 text-center"
                        style={{
                            background: `${theme.primary}11`,
                            border: `1px solid ${theme.light}22`,
                            color: theme.light,
                        }}
                    >
                        <div className="text-5xl mb-3">📖</div>

                        <h3 className="text-lg font-bold mb-2">
                            راهنمایی ثبت نشده است
                        </h3>

                        <p className="text-sm opacity-80">
                            در حال حاضر محتوایی برای نمایش وجود ندارد.
                        </p>
                    </div>
                </RenderIf>
            </div>
        </Modal>
    );
}

export default GamificationGuideModal;